import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageService } from '../../services/page.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NumPedidoModalComponent } from '../../modal/num-pedido-modal/num-pedido-modal.component';

@Component({
  selector: 'app-gestion-users',
  templateUrl: './gestion-users.component.html',
  styleUrls: ['./gestion-users.component.css'],
})
export class GestionUsersComponent implements OnInit {
  users: any;
  dataSoruce;
  columns: string[] = ['colaborador', 'email', 'rol', 'actions'];
  colaboradores: any;
  colaboradoresFilter: any;
  grupos: any[] = ['Grupo 1', 'Grupo 2'];
  rol;
  addForm: FormGroup;
  passForm: FormGroup;
  dataForm: FormGroup;
  colaborador;
  rangos: any = [];
  seleccionado: any;

  @ViewChild('MatPaginator', { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ViewChild('password', { static: true }) passDialog: TemplateRef<any>;
  @ViewChild('data', { static: true }) dataDialog: TemplateRef<any>;
  @ViewChild('delete', { static: true }) deleteDialog: TemplateRef<any>;

  constructor(
    private pageService: PageService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formInit();
    this.getUsers();
    this.getRangos();

    this.pageService.getColaboradoresGrupos().subscribe((res) => {
      if (res) {
        this.colaboradores = res.colaboradores;
        this.colaboradoresFilter = this.colaboradores;
        this.grupos = res.grupos;
      }
    });
  }

  numPedidoModal(): void {
    const dialogRef2 = this.dialog.open(NumPedidoModalComponent, {
      width: '400px',

      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog',
    });
  }

  getUsers(): void {
    this.pageService.getUsers().subscribe(
      (res) => {
        if (res) {
          this.users = res;
          console.log(this.users);
          this.dataSoruce = new MatTableDataSource();
          this.dataSoruce.data = this.users;
          this.setFilters();
        }
      },
      (error) => {
        if (error.status === 403) {
          sessionStorage.clear();
          this.router.navigateByUrl('/login');
        }
      }
    );
  }

  setFilters(): void {
    this.dataSoruce.paginator = this.paginator;
    this.dataSoruce.sort = this.sort;
  }

  formInit(): void {
    this.addForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      pass: new FormControl('', [Validators.required, Validators.minLength(6)]),
      rol: new FormControl('', Validators.required),
      colaborador: new FormControl(''),
      grupo: new FormControl(''),
    });
    this.passForm = new FormGroup({
      pass: new FormControl('', [Validators.required, Validators.minLength(6)]),
    });

    this.dataForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      rol: new FormControl(''),
    });
  }

  setRol(): void {
    this.rol = this.addForm.value.rol;
  }

  addUser(): void {
    if (this.addForm.valid) {
      console.log(this.addForm.value);
      this.pageService
        .postUser(
          this.addForm.value.colaborador === ''
            ? this.addForm.value.grupo
            : this.addForm.value.colaborador,
          this.addForm.value.email,
          this.addForm.value.rol,
          this.addForm.value.pass
        )
        .subscribe((res) => {
          if (res === 'CREATED') {
            this.getUsers();
            this.addForm.reset();
            this.rol = '';
          }
        });
    }
  }

  //Modal password
  setPassword(colaborador): void {
    const dialogRef = this.dialog.open(this.passDialog, {
      hasBackdrop: true,
      width: '300px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.pageService
          .forcePassword(colaborador.email, this.passForm.value.pass)
          .subscribe(
            (res) => {
              if (res === 'UPDATED') {
                this.snackbar.open('Contraseña actualizada', 'OK', {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: ['snack-gestion'],
                });
              } else {
                this.snackbar.open(
                  'Ha ocurrido un problema, pruebe mas tarde.',
                  'OK',
                  {
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: ['snack-gestion'],
                  }
                );
              }
              this.passForm.reset();
            },
            (err) => {
              this.snackbar.open(
                'Ha ocurrido un problema, contacte con el administrador.',
                'OK',
                {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: ['snack-gestion'],
                }
              );
            }
          );
      }
    });
  }

  setData(colaborador): void {
    this.colaborador = colaborador;
    console.log(this.colaborador.rol);
    this.dataForm.setValue({
      email: colaborador.email,
      rol: colaborador.rol,
    });
    if (colaborador.rol === 'GRUPO') {
      this.dataForm.controls['rol'].disable();
    } else {
      this.dataForm.controls['rol'].enable();
    }
    const dialogRef = this.dialog.open(this.dataDialog, {
      hasBackdrop: true,
      width: '300px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.pageService
          .updateUser(
            colaborador.email,
            this.dataForm.value.email,
            this.dataForm.value.rol
          )
          .subscribe(
            (res) => {
              if (res === 'UPDATED') {
                this.snackbar.open('Datos actualizados', 'OK', {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: ['snack-gestion'],
                });
                this.getUsers();
              } else {
                this.snackbar.open(
                  'Ha ocurrido un problema, pruebe mas tarde.',
                  'OK',
                  {
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: ['snack-gestion'],
                  }
                );
              }
              this.dataForm.reset();
            },
            (err) => {
              this.snackbar.open(
                'Ha ocurrido un problema, contacte con el administrador.',
                'OK',
                {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: ['snack-gestion'],
                }
              );
            }
          );
      }
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSoruce.filter = filterValue.trim().toLowerCase();
  }

  getRangos(): void {
    this.pageService.getRangos().subscribe((res) => {
      console.log(res);
      this.rangos = res;
      this.rangos.map((a) => {
        if (a.dafault === true) {
          this.seleccionado = a.id;
        }
      });
      console.log(this.seleccionado);
    });
  }

  updateHistorico(): void {
    this.pageService.updateDefaultRango(this.seleccionado).subscribe((res) => {
      console.log(res);
    });
  }

  deleteUser(user): void {
    console.log(user);
    const dialogRef = this.dialog.open(this.deleteDialog, {
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pageService.deleteUser(user.idUser).subscribe((res) => {
          this.getUsers();
        });
      }
    });
  }
}
